<template>
  <div :id="random_id"
       v-bind="$attrs"
       :data-testid="dataTestid"
       :class="twMerge('min-w-full' , appendClass)">
    <TsCard dataTestId="atom-card"
            :appendClass="twMerge(backgroundColorClass, 'rounded-xl')"
            type="vertical" :data-testid="dataTestid+'-card'">
      <template class="text-left" #default>
        <div class="p-4 sm:max-md:p-6 flex flex-col md:flex-row items-center gap-x-6 text-natural-grey dark:text-gray-400">
          <TsImage
              :class="twMerge(
                  'rounded-lg ms-1 md:size-20 max-md:mb-4',
                  imageClass
              )"
              :src="image":data-testid="dataTestid+'-image'" loading="lazy"/>
          <div class="w-full">
            <slot name="heading">
              <h3 v-if="props.heading" class="text-[1.5rem] font-semibold" :style="props.headingStyles">
                {{ props.heading }}
              </h3>
            </slot>
            <slot name="description">
              <span v-if="props.description" class=" font-medium text-[1.2rem] mt-1">
                {{ props.description }}
              </span>
            </slot>
          </div>
        </div>
      </template>
    </TsCard>
  </div>
</template>

<script setup lang="ts">

import {useRandomUUID} from "~/composables/useRandomUUID";
import {twMerge} from "tailwind-merge";
import {onMounted, ref} from "vue";

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type Props = {
  appendClass?: string;
  imageClass?: string;
  heading?: string;
  description?: string;
  image?: string;
  backgroundColorClass?: string;
  dataTestid?: string;
  headingStyles?: object;
};

const props = withDefaults(defineProps<Props>(), {
  heading: '7 Days',
  description: 'Available',
  image: '/images/cardImage.webp',
  imageClass: '',
  appendClass: '',
  backgroundColorClass: 'bg-[#eaecf9]',
});
const random_id = ref('');
onMounted(() => {
  random_id.value = useRandomUUID();
});

</script>
